<template>
  <div class="card-review-skeleton">
    <div class="card-review-skeleton__header">
      <div class="card-review-skeleton__avatar card-review-skeleton--pulse" />
      <div class="card-review-skeleton__meta">
        <div class="card-review-skeleton__line card-review-skeleton__line--name card-review-skeleton--pulse" />
        <div class="card-review-skeleton__line card-review-skeleton__line--role card-review-skeleton--pulse" />
      </div>
    </div>

    <div class="card-review-skeleton__content">
      <div class="card-review-skeleton__line card-review-skeleton__line--text card-review-skeleton--pulse" />
      <div class="card-review-skeleton__line card-review-skeleton__line--text-short card-review-skeleton--pulse" />
    </div>

  </div>
</template>
<style lang="scss" scoped>
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.card-review-skeleton {
  background: #FFFFFF;
  border: 1px solid #0000001A;
  display: flex;
  flex-direction: column;
  
  // Matching real card spacing
  @include vwUnit('padding', 28, 48);
  @include vwUnit('border-radius', 8.58, 8);
  @include vwUnit('gap', 24, 20);

  &--pulse {
    background: linear-gradient(90deg, #f0f0f0 25%, #f8f8f8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite linear;
  }

  &__header {
    display: flex;
    align-items: center;
    @include vwUnit('gap', 11, 11);
  }

  &__avatar {
    flex-shrink: 0;
    @include vwUnit('width', 62.91, 50);
    @include vwUnit('height', 62.91, 50);
    border-radius: 50%;
  }

  &__meta {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 4px;
  }

  &__line {
    border-radius: 4px;
    height: 14px;

    &--name {
      height: 20px;
      width: 40%;
    }

    &--role {
      height: 14px;
      width: 25%;
    }

    &--text {
      width: 100%;
    }

    &--text-short {
      width: 60%;
    }

    &--link {
      width: 80px;
      height: 12px;
    }
  }
}
</style>
